import { REGION_HREFLANG } from '../config/publicRegions';

export const REGION_WATCH_COUNTRY = {
  us: 'US',
  gb: 'GB',
  au: 'AU',
  ie: 'IE',
  de: 'DE',
  at: 'AT',
  es: 'ES',
  it: 'IT',
  fr: 'FR',
  pt: 'PT',
  nl: 'NL',
  no: 'NO',
  fi: 'FI',
  dk: 'DK',
  se: 'SE',
};

export function serverLanguageFromRegion(region) {
  return REGION_HREFLANG[region] || 'en-US';
}

export function watchRegionFromSiteRegion(region) {
  return REGION_WATCH_COUNTRY[region] || 'US';
}
